module.exports = __webpack_public_path__ + "static/uniswap-uni-logo-d4f8acef0bc39dc0366bfbf98a961541.png";